// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-collections-index-list-bkyep{display:grid;grid-gap:24px}.pages-collections-index-list-bkyep.pages-collections-index-desktop-qkueb{grid-template-columns:repeat(4,1fr)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": "pages-collections-index-list-bkyep",
	"desktop": "pages-collections-index-desktop-qkueb"
};
module.exports = ___CSS_LOADER_EXPORT___;
